import {daysBetween, getTomorrowStartTime, getTodayStartTime} from 'shared/utils/dateTime';
import {valueOf} from 'core/Budget';
import {redistributeBudget} from 'core/LifeCycle';

export function stateToWidget(settings: CoreState): DeviceWidgetData {
  const {budget, dailyBudget} = settings;
  const daysLeft = Math.max(daysBetween(budget.finishDate, getTodayStartTime()), 0);
  const totalSum = valueOf(budget);
  const todayLimit = Math.max(dailyBudget.amount, 0);

  const nextDayStart = getTomorrowStartTime();
  const nextDayBudget = {...budget, spent: budget.spent + todayLimit};
  const nextDaySettings: CoreState = {...settings, budget: nextDayBudget, history: []};

  const tomorrowLimit =
    daysLeft <= 1 ? 0 : redistributeBudget(nextDaySettings, nextDayStart).dailyBudget.amount;

  return {
    todayLimit,
    tomorrowLimit,
    totalSum,
    daysLeft,
  };
}
